import { CustomersApi, VesselPropertiesApi, VesselsApi } from '@rhim/rest/customerManagement';
import { Configuration } from '@rhim/rest/wearManagement';

const configuration: Configuration = {} as Configuration;

const BASE_URL = '/api/customermanagement/v2';

export const vessels = new VesselsApi(configuration, BASE_URL);
export const vesselProperties = new VesselPropertiesApi(configuration, BASE_URL);
export const customers = new CustomersApi(configuration, BASE_URL);
